<template>
  <section
    class="RedirectingPage"
  >
    Redirecting…
  </section>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.RedirectingPage {
  display: grid;
  place-items: center;
  height: 100%;

  background-color: var(--themeColorPrimary);
  color: var(--themeColorNeutral0);

  font-size: 18px;
  font-stretch: var(--fontWidthExtended);
}
</style>
